import { Money } from "classes/DecimalClasses";

import { isoToLocalDateTime } from "services/utility/dates";

import { SOS_BILLING_CURRENCY_CODE } from "appConstants";

export function afterGet(record) {
  const newRecord = {
    ...record,
    date: isoToLocalDateTime(record.date),
    amount: new Money(record.amount, SOS_BILLING_CURRENCY_CODE),
  };

  return newRecord;
}
